import React from "react";
import "./UserBadge.scss";

import IconLogout from "gruppocap-ui-fe/dist/resources/img/icons/new_logout_icon.svg";
import IconLogoutBlack from "gruppocap-ui-fe/dist/resources/img/icons/new_logout_icon_blue.svg";
// import {useHistory} from "react-router";
import { useSelector, useDispatch } from "react-redux";
import Language from "../Language/Language";
import { languageHandler } from "../../../reducers/language";
import { GetCustomerComposedName, setCookie } from "../../../helpers/helpers";
import { Link } from "react-router-dom";
import { CookieLanguageInfoEnum } from "../../../helpers/enums";
import { useTranslation } from "react-i18next";

const UserBadge = (props) => {
  const user = useSelector((state) => state.auth && state.auth.user);
  const profile = useSelector((state) => state.auth.profile);
  const dispatch = useDispatch();

  const changeLanguages = (language) => {
    setCookie({
      name: CookieLanguageInfoEnum.name,
      value: language,
      options: { path: CookieLanguageInfoEnum.path },
    });
    dispatch(languageHandler(language));
  };
  const { t } = useTranslation();
  return (
    <div className="UserBadge" data-testid="UserBadge">
      <div className="user-info d-flex">

        { user && user.role !== "PROSPECT" ? (
          props.mobile ? (
            <div className="user-info__logged-box">
              <div className="user-info__content">
                <i className="gc-icon-functional-profile-1-col" aria-hidden="true"></i>
                <div className="go-to-reserved-area"><Link className="user-info__fullname" to={"/"}>
                    {profile !== null && GetCustomerComposedName(profile)}
                </Link>
                <Link className="paragraph-main-fs8" to={"/"}>
                    {t("private.go.to.reserved.area")}
                </Link></div>
              </div>
              {profile !==null ? <Link className="user-info__cta" to={"/logout"}><img src={IconLogoutBlack} aria-hidden="true"/></Link> : null}
            </div>
          ) : (
            <div className="user-info__logged-box">
              <Link className="user-info__fullname gcap-cta header-link header-link-font-color-2" to={"/"}>
                  <span>{profile !== null && GetCustomerComposedName(profile)}</span>
              </Link>
              {profile !==null ? <Link className="user-info__cta" to={"/logout"}><img src={IconLogout} aria-hidden="true"/></Link>  : null}
            </div>
          )
        ) : (
           props.mobile ? (
              <div className={"user-badge user-unlogged"}>
                <a className="gcap-cta header-link header-link-icon header-link-font-color-2" href="#">
                  <i className="gc-icon-functional-profile-1-col" aria-hidden="true"></i>
                  <span>{t("common.back.home")}</span>
                </a>
              </div>
           ) : (
              <div className={"user-badge user-unlogged"}>
                <a className="gcap-cta header-link header-link-icon header-link-font-color-2" href="#">
                  <span>{t("common.back.home")}</span>
                  <i className="gc-icon-functional-profile-1-col" aria-hidden="true"></i>
                </a>
              </div>
           )
        )}
      </div>
    </div>
  );
};

UserBadge.propTypes = {};

export default UserBadge;
